module.exports = __webpack_public_path__ + "img/goal.6ac20510.svg";